import {Helmet} from 'react-helmet-async'
import {useLocation} from 'react-router-dom'
import {SEO_CONFIG} from '../core/_const'
import {buildDocumentTitle, isNonProduction} from '../core/_helpers'
import {SeoMetadata} from '../core/_models'

interface SeoHeadProps {
  /** Override SEO data (for dynamic pages like blog posts) */
  seo?: Partial<SeoMetadata>
}

export const SeoHead: React.FC<SeoHeadProps> = ({seo}) => {
  const {pathname} = useLocation()
  const configData = SEO_CONFIG[pathname]
  const title = seo?.title || configData?.title || 'ShipBae'
  const description = seo?.description || configData?.description || ''
  const keywords = seo?.keywords || configData?.keywords || ''

  return (
    <Helmet>
      <title>{buildDocumentTitle(title)}</title>
      {description && <meta name='description' content={description} />}
      <meta name='keywords' content={keywords} />
      {isNonProduction() && <meta name='robots' content='noindex, nofollow' />}
    </Helmet>
  )
}
